export const accountGetters = {
  account: (state) => state.account,
  client_settings: (state) => {
    return JSON.parse(state?.account?.client?.settings);
  },
  believe_special: (state) => {
    return JSON.parse(state?.account?.client?.settings || null)?.believe_special == 'enable';
  },
  routeBeforeBlock: (state) => state.routeBeforeBlock,
}